<template lang="html">
  <div class="bedroom-suite-deluxe">
    <div class="container">

      <div class="row"> <!-- Titulo -->
      <h2 class="title">{{$t('telas.quartos.suite_deluxe.titulo')}}</h2>
      </div>

      <div class="row">
        <div class="col-md-6 col-lg-6 bedroom-suite-deluxe-slide">
          <slider v-if="!errorSlider" :item="images" :radius="true"></slider>
        </div> <!-- col -->
        <div class="col-md-6 col-lg-6 bedroom-suite-deluxe-slide">
          <div class="config">
            <h5 class="title">{{$t('telas.quartos.suite_deluxe.informacoes_do_quarto.titulo')}}</h5>
            <p class="txt-descricao lb">{{$t('telas.quartos.suite_deluxe.informacoes_do_quarto.descricao')}}</p>

              <table class="table table-striped">
                <tbody>
                  <tr>
                    <th class="lb" scope="row">{{$t('telas.quartos.suite_deluxe.maximo_de_hospedes.titulo')}}</th>
                    <td class="lb">{{$t('telas.quartos.suite_deluxe.maximo_de_hospedes.descricao')}}</td>
                  </tr>
                  <tr>
                    <th class="lb" scope="row">{{$t('telas.quartos.suite_deluxe.tamanho_das_camas.titulo')}}</th>
                    <td class="lb">{{$t('telas.quartos.suite_deluxe.tamanho_das_camas.descricao')}}</td>
                  </tr>
                  <tr>
                    <th class="lb" scope="row">{{$t('telas.quartos.suite_deluxe.tamanho_do_quarto.titulo')}}</th>
                    <td class="lb">{{$t('telas.quartos.suite_deluxe.tamanho_do_quarto.descricao')}}</td>
                  </tr>
                </tbody>
              </table>
          </div>
        </div>
      </div> <!-- row -->

      <div class="row row-comodidades">
        <h5 class="title">{{$t('telas.quartos.suite_deluxe.comodidades.titulo')}}</h5>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-6" style="margin-bottom:25px;">

          <div class="item-comodidade">
            <div class="row">
              <h5 class="titulo-item-comodidade">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.titulo')}}</h5>
            </div>
            <hr>
            <div class="content">
              <ul>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.tv')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.cofre')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.cama_extra_longa')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.pizo_marmore_asulejo')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.frigobar')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.ar_condicionado')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.tomada')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.travesseiro')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.wifi')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.toalhas')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.roupao')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.roupa_de_cama')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.quarto.guarda_roupa_ou_armario')}}</li>
              </ul>
            </div>
          </div><br>

          <div class="item-comodidade">
            <div class="row">
              <h5 class="titulo-item-comodidade">{{$t('telas.quartos.suite_deluxe.comodidades.banheiro_privativo.titulo')}}</h5>
            </div>
            <hr>
            <div class="content">
              <ul>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.banheiro_privativo.hidromassagem')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.banheiro_privativo.chuveiro')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.banheiro_privativo.vaso_sanitario')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.banheiro_privativo.itens_higiene_pessoal')}}</li>
              </ul>
            </div>
          </div>

        </div>
        <div class="col-md-6 col-lg-6">

          <div class="item-comodidade">
            <div class="row">
              <h5 class="titulo-item-comodidade">{{$t('telas.quartos.suite_deluxe.comodidades.varanda.titulo')}}</h5>
            </div>
            <hr>
            <div class="content">
              <ul>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.varanda.jardim')}}</li>
              </ul>
            </div>
          </div><br>

          <div class="item-comodidade">
            <div class="row">
              <h5 class="titulo-item-comodidade">{{$t('telas.quartos.suite_deluxe.comodidades.entretenimento.titulo')}}</h5>
            </div>
            <hr>
            <div class="content">
              <ul>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.entretenimento.tabuleiro')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.entretenimento.quebra_cabeca')}}</li>
              </ul>
            </div>
          </div><br>

          <div class="item-comodidade">
            <div class="row">
              <h5 class="titulo-item-comodidade">{{$t('telas.quartos.suite_deluxe.comodidades.piscina.titulo')}}</h5>
            </div>
            <hr>
            <div class="content">
              <ul>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.piscina.ceu_aberto')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.piscina.lado_raso')}}</li>
                <li class="txt-descricao">{{$t('telas.quartos.suite_deluxe.comodidades.piscina.lado_fundo')}}</li>
              </ul>
            </div>
          </div>

        </div>
      </div> <!-- row -->

      <div class="row row-btn">
        <p><button type="button" @click="rota('SelectDatesReservation')" class="btn btn-success" name="button">{{$t('telas.quartos.reservar_este_quarto')}}</button> </p>
      </div>

      <reserva :header="true" :headerTitle="$t('telas.quartos.verificar_disponibilidade')"></reserva>

    </div> <!-- container -->

  </div>
</template>

<script>
import reserva from '../../../components/reservation-component/ReservationComponent'
import slider from '../../../components/slider/Slider'

export default {
  name: 'SuiteDeluxe',

  components: {
    reserva,
    slider
  },

  data() {
    return {
      images: {
        id: '1',
        imagesUrl: [],
        slideError: false
      }
    }
  },

  computed: {
    errorSlider() {
      return this.slideError
    }
  },

  created() {
    this.slideError = false

    for(let i = 1; i <= 10; i++) {
      this.images.imagesUrl.push(require(`@/assets/img/quartos/suite2/${i}.jpg`))
    }
  },

  methods: {
    rota(route){
      this.$router.push({name: route});
    },
  }
}
</script>

<style lang="css" scoped>
@import url('https://fonts.googleapis.com/css?family=Quicksand');

.bedroom-suite-deluxe {
  background-color: white;
  font-family: 'Quicksand', sans-serif;
  padding-bottom: 80px;
  padding-top: 100px;
}
.bedroom-suite-deluxe div.container div.row h2.title {
  width: 100%;
  text-align: center;
  color: rgb(118, 106, 49);
  font-weight: bold;
}
#CarrouselSuiteDeluxe, .container-slide, .border-img-slide {
  border-radius: 5px;
}
.bedroom-suite-deluxe div.container div.row .bedroom-suite-deluxe-slide {
  padding-top: 20px;
}

.bedroom-suite-deluxe div.container div.row-comodidades {
  margin-top: 50px;
  margin-bottom: 30px;
}

.bedroom-suite-deluxe div.container h5.title {
  width: 100%;
  text-align: center;
  font-weight: bold;
  color: #444;
}

.bedroom-suite-deluxe div.container div.row div.item-comodidade {
  padding: 10px;
  background-color: white;
}
.bedroom-suite-deluxe div.container div.row div.item-comodidade h5.titulo-item-comodidade {
  width: 100%;
  text-align: center;
  color: black;
}

.bedroom-suite-deluxe div.container div.row h5.titulo-descricao {
  color: black;
  width: 100%;
  text-align: center;
  font-weight: bold;
}

.bedroom-suite-deluxe div.container div.row p.txt-descricao {
  text-align: justify;
}

.bedroom-suite-deluxe div.container div.row .txt-descricao {
  font-size: 18px;
  color: black
}
.bedroom-suite-deluxe div.container div.row .bedroom-suite-deluxe-slide .lb,
.bedroom-suite-deluxe div.container div.row .row .lb {
  color: black;
}

.bedroom-suite-deluxe div.container .row-btn p {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/bedroom/suite-deluxe/SuiteDeluxe.vue